// extracted by mini-css-extract-plugin
module.exports = {"icon":"edicons-module_icon_1tWkL"};